import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { trackEvent, setUserId } from '../../../lib/analytics';

const SocialCallback = ({ ...props }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const code = new URL(window.location.href).searchParams.get("code");

    useEffect(() => {
        const handleLogin = async () => {
            try {
                const platform = location.pathname.split('/').pop();
                const res = await axios.post(`/api/sign/oauth2/callback/${platform}`, { code });

                // 응답 데이터 구조 확인
              //  console.log('응답 데이터:', res.data);

                const { nickName, token, authorStatus  } = res.data;
                const platformStr = location.pathname.split('/').pop();

                // GA4 이벤트 전송
                trackEvent('sign_up', {
                    provider: platformStr,
                    page_path: window.location.pathname,
                });

                // user_id 설정 (서버에서 id나 email을 준다고 가정하거나, 최소한 nickName이라도 설정)
                if (res.data.email) {
                    setUserId(res.data.email);
                } else if (nickName) {
                    setUserId(nickName);
                }

                // 데이터가 undefined인지 확인
                if (!nickName || !token) {
                    throw new Error('데이터가 유효하지 않습니다.');
                }
                window.opener.postMessage({
                    status: 'success',
                    token,
                    nickName,
                    authorStatus,
                    platform: location.pathname.split('/').pop()
                }, window.location.origin);
                window.close();
            } catch (error) {
              //  console.error('로그인 실패:', error);
                window.opener.postMessage({
                    status: 'error',
                    reson:'null',
                    platform: location.pathname.split('/').pop()
                }, window.location.origin);
                window.close();
            }
        };
        handleLogin();
    }, []);


    const containerStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
    };

    const noticeStyle: React.CSSProperties = {
        textAlign: 'center',
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    };

    const spinnerStyle: React.CSSProperties = {
        margin: '20px auto',
        width: '40px',
        height: '40px',
        border: '4px solid rgba(0, 0, 0, 0.1)',
        borderTop: '4px solid #000',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
    };

    const keyframesStyle = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;




    return (
        <div className="LoginHandeler" style={containerStyle}>
            <div className="notice" style={noticeStyle}>
                <p>로그인 중입니다.</p>
                <p>잠시만 기다려주세요.</p>
                <div className="spinner" style={spinnerStyle}></div>
            </div>
            <style>{keyframesStyle}</style>
        </div>
    );

};

export default SocialCallback;
